import React, { useState } from 'react';
import SecurityIcon from '@mui/icons-material/Security';
import StandardButton from '../Button/StandardButton';
import useApplication from '../../hooks/useApplication.hooks';

type OpenWindowProps = {
    title: string;
    url: string;
    onWindowClose: () => void;
};

const OpenWindow = (props: OpenWindowProps) => {
    const { url, onWindowClose, title } = props;
    const [newWindow, setNewWindow] = useState<Window | null>(null);
    const { isLoading, setIsLoading } = useApplication();

    const openGoogleOAuth = () => {
        setIsLoading(true);
        const win = window.open(url, '_blank', 'width=600,height=400');
        setNewWindow(win);

        const timer = setInterval(() => {
            if (win?.closed) {
                clearInterval(timer);
                onWindowClose(); // Call the callback when the window is closed
            }
        }, 500);
    };

    return (
        <StandardButton fullWidth onClick={openGoogleOAuth} icon={<SecurityIcon />}>
            {title}
        </StandardButton>
    );
};

export default OpenWindow;
